import { DARK_MUTED } from './darkmuted';

export const HEADER_NAVIGATION = {
  headerNavigationFill: DARK_MUTED.darkmuted600,
};
